import * as React from 'react';
import Lottie from 'lottie-react-web';
import { Loader } from '../assets/images/loader';

const Loading = (props: { className?: string; visible?: boolean }) => {
  const options = {
    animationData: Loader,
  };
  let className = 'loaderWrapper';
  if (props.className) {
    className += ' ' + props.className;
  }
  const style =
    props.visible === undefined
      ? undefined
      : {
          display: props.visible ? undefined : 'none',
        };

  return (
    <div className={className} style={style}>
      <div className="loader">
        <Lottie options={options} />
      </div>
    </div>
  );
};
export default Loading;
